import React from "react";
import { Box } from "@mui/material";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";

import { app_base_url } from "../Utils/Urls";
import { Login } from "../Pages/Auth/Login";
import { AutoCadastro } from "../Pages/Auth/AutoCadastro";
import { RecuperarSenha } from "../Pages/Auth/RecuperarSenha";
import { RedefinirSenha } from "../Pages/Auth/RedefinirSenha";
import { FooterSuporte } from "../Components/FooterSuporte";

export function AuthRoutes() {
  return (
    <Router>
      <Routes>
        <Route
          path={`${app_base_url}/autocadastro`}
          element={<AutoCadastro />}
        ></Route>
        <Route
          path={`${app_base_url}/redefinir-senha/`}
          element={<RedefinirSenha />}
        ></Route>

        <Route
          path={`${app_base_url}/recuperar-senha`}
          element={<RecuperarSenha />}
        ></Route>

        {/*EMKAIL INDO COM ENDEREÇO ERRADO */}
        <Route
          path={`${app_base_url}${app_base_url}/autocadastro`}
          element={<AutoCadastro />}
        ></Route>
        <Route
          path={`${app_base_url}${app_base_url}/redefinir-senha/`}
          element={<RedefinirSenha />}
        ></Route>

        <Route
          path={`${app_base_url}${app_base_url}/recuperar-senha`}
          element={<RecuperarSenha />}
        ></Route>



        <Route path={`${app_base_url}/*`} element={<Login />}></Route>

      </Routes>

      {/* Canais de suporte fixos no topo-esquerdo (as telas de auth não têm header) */}
      <Box sx={{ position: "fixed", top: 16, left: 16, zIndex: 1300 }}>
        <FooterSuporte variant="inline" />
      </Box>
    </Router>
  );
}
